// extracted by mini-css-extract-plugin
module.exports = {"container":"solar_container__2Cq9U","title":"solar_title__2VcYd","box":"solar_box__2BsL2","insta":"solar_insta__40t21"};